import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/primeng';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-associations-management',
  templateUrl: './associations-management.component.html',
  styleUrls: ['./associations-management.component.scss']
})
export class AssociationsManagementComponent implements OnInit {
  items: MenuItem[] = [];
  activeTabIndex = 0;

  constructor(
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.translateService.get([
      'menu.administrationUsers',
      'menu.administrationCompanies',
      'menu.administrationApplications'
    ]).subscribe(res => {
      this.items.push({label: res['menu.administrationUsers']});
      this.items.push({label: res['menu.administrationCompanies']});
      this.items.push({label: res['menu.administrationApplications']});
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/associations-management/associations-management.component.ts